module.exports = __webpack_public_path__ + "img/c01_unittechdivinevision_Normal_ua.318406bb.webp";